<div class="row pb-2 title-component">
  <div tabindex="0" role="heading" aria-live="assertive" class="col-12" [ngStyle]="getTitleStyle(component)" [innerHTML]="getHtml(component.primary.title, vehicle)">
  </div>
</div>
